import $ from 'jquery'

export default animatedOnVisible

/** @ngInject */
function animatedOnVisible($timeout) {
    return ({
        restrict: 'A',
        link: {
            post(scope, element, attr) {
                const animate = function () {
                    const $window = $(window)
                    const elementOffsetBottom = element.offset().top + (element.height() / 1.8)
                    const viewportBottom = $window.scrollTop() + $window.height()
                    if ((viewportBottom >= elementOffsetBottom) && !element.hasClass('animated')) {
                        element.removeClass('visibility-hidden')
                        return element.addClass(`${attr.animatedOnVisible} animated`)
                    }
                }

                $(window).on('scroll.animatedOnVisible', () => animate())

                element.addClass('visibility-hidden')
                $timeout(animate)

                return scope.$on('$destroy', () => $(window).off('.animatedOnVisible'))
            },
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/landing/animatedOnVisible.js